export default __webpack_public_path__ + "static/media/2102.a8eeb363.png";